<!--
    file type .....: HTML file: globalsearch.component.html
    Created By ....: ianday
    Date ..........: 8/28/23 
-->
<div class="globalsearch-container">
    <!-- query criteria -->
    <div style="height: 235px;">
        <div class="dwform" style="padding-right:15px;">
            <!-- first Row -->
            <div  style="width: 1085px;">

                <div style="display: inline-block;width:33%; text-align: left">
                    <label class="label-field-override">Case Number:</label>
                    <span class="form-required"> </span>

                    <input mat-input [disabled]="disabledFlag"
                           matTooltip="Enter a case number (or part of a case number)"
                           id="caseNumberId"
                           class="input-field-short"
                           [(ngModel)]="searchQBE.caseNumber">
                </div>
                <!-- first Name -->
                <div style="display: inline-block; width:33%; text-align: left">
                <label class="label-field-override">First Name:</label>
                <span class="form-required"> </span>

                <input mat-input [disabled]="disabledFlag"
                       matTooltip="First (Christian) Name"
                       class="input-field-short" style="width:200px;"
                       [(ngModel)]="searchQBE.firstName">
                </div>
                <!-- last name -->
                <div style="display: inline-block;width:34%; text-align: left">
                <label class="label-field-override">Last Name:</label>
                <span class="form-required"> </span>
                <input mat-input [disabled]="disabledFlag"
                       matTooltip="Last name or given name"
                       class="input-field" style="width:200px;"
                       [(ngModel)]="searchQBE.lastName">

                </div>
            </div>

            <div class="dwform-row-gap"></div>

            <!-- second row -->
            <div  style="width: 1085px;margin-top: 3px;" >

                <!-- Date of Birth -->
                <div style="display: inline-block;width:33%; text-align: left" *ngIf="showDateOfBirth">
                <label class="label-field-override">Date of Birth:</label>
                <span class="form-required"> </span>

                <input mat-input [disabled]="disabledFlag"
                       id="dobId"
                       style="width: 90px"
                       mask="9999-99-99"
                       showMaskTyped="true"
                       [dropSpecialCharacters]="false"
                       class="input-field-short"
                       matTooltip="Format: YYYY-MM-DD"
                       [(ngModel)]="searchQBE.dateOfBirth">
                </div>

                <!-- Email -->
                <div style="display: inline-block;width:33%; text-align: left">
                <label class="label-field-override">Email:</label>
                <span class="form-required"> </span>

                <input mat-input [disabled]="disabledFlag"
                       matTooltip="email address format name@domain.com"
                       class="input-field-short" style="width:200px;"
                       [(ngModel)]="searchQBE.emailAddress">
                </div>

                <!-- telephone -->

                <div style="display: inline-block;width:33%; text-align: left">
                    <label class="label-field-override">Telephone:</label>
                    <span class="form-required"> </span>

                    <input matInput class="input-field-short" id="phoneNumber"
                           [dropSpecialCharacters]="false"
                           showMaskTyped="true"
                           mask="(999) 999-9999"
                           [disabled]="disabledFlag"
                           [(ngModel)]="searchQBE.phoneNumber"
                           placeholder="<Telephone>"
                           type="text"/>
                </div>
            </div>

            <div class="dwform-row-gap"></div>
            <div style="display: inline-block; width:100%;">
                <div style="display: inline-block; width: 710px;">
                <!-- third row -->
                <div  style="width: 695px;">
                    <div style="display: inline-block; width:51%; ">
                        <label class="label-field-override">Request Type:</label>
                        <span class="form-required"> </span>

                        <dw-dropdown
                                [controlWidth]="'160px'"
                                [dataSource]="requestTypeDataSource"
                                [selectedItem]="searchQBE.requestType"
                                (itemSelected)="searchQBE.requestType = $event">

                        </dw-dropdown>
                          <!-- Clear button -->
                            <button mat-icon-button (click)="clearRequestTypeDropDown()" style="width:0px;">
                                <mat-icon aria-label="Clear selection" style="font-size:10pt;width:20px;cursor: pointer;">clear</mat-icon>
                            </button>
                    </div>
                    <div style="display: inline-block;width:49%; text-align: left" *ngIf="unlimitedAgencyfilter">

                        <label class="label-field-override" style="width:93px">Agency:</label>
                        <span class="form-required"> </span>

                        <input mat-input [disabled]="disabledFlag"
                               matTooltip="Enter an agency name or part or an agency name"
                               class="input-field" style="width: 200px;"
                               [(ngModel)]="searchQBE.agencyName">
                    </div>
                </div>
                <!-- forth row -->
                <div class="dwform-row-gap"> </div>
                <div  style="width: 685px;">
                    <div style="display: inline-block; width:52%; text-align: left">
                        <label class="label-field-override">Use Date:</label>
                        <span class="form-required"> </span>
                        <dw-dropdown
                                [controlWidth]="'160px'"
                                [dataSource]="useDateRecs"
                                [selectedItem]="searchQBE.useDate"
                                (itemSelected)="searchQBE.useDate = $event">
                        </dw-dropdown>
                    </div>
                    <div style="display: inline-block; width:48%; text-align: left">
                        <label class="label-field-override" style="width:98px;">From: </label>
                        <input mat-input [disabled]="disabledFlag"
                               id="dateFromId"
                               style="width: 85px"
                               mask="9999-99-99"
                               showMaskTyped="true"
                               [dropSpecialCharacters]="false"
                               class="input-field-short"
                               matTooltip="Format: YYYY-MM-DD"
                               [(ngModel)]="searchQBE.dateFrom">

                        <span style="margin-left: 0px;margin-right: 5px;">To:</span>
                        <input matInput [disabled]="disabledFlag" style="width: 85px"
                               id="dateToId"
                               mask="9999-99-99"
                               showMaskTyped="true"
                               [dropSpecialCharacters]="false"
                               class="input-field-short"
                               matTooltip="Format: YYYY-MM-DD"
                               [(ngModel)]="searchQBE.dateTo">
                    </div>
                </div>
                <div class="dwform-row-gap-half"> </div>

                <!-- fifth row -->
                    <div  style="width: 685px;">
                        <div style="display: inline-block; width:52%; text-align: left">
                            <label class="label-field-override">Modified By:</label>
                            <span class="form-required"> </span>

                            <dw-dropdown
                                    [controlWidth]="'200px'"
                                    [dataSource]="usersList"
                                    [selectedItem]="searchQBE.lastModifiedBy"
                                    (itemSelected)="searchQBE.lastModifiedBy = $event">
                            </dw-dropdown>

                            <!-- Clear button -->
                            <button mat-icon-button (click)="clearLastModifiedBy()" style="width:0px;">
                                <mat-icon aria-label="Clear selection" style="font-size:10pt;width:20px;cursor: pointer;">clear</mat-icon>
                            </button>
                        </div>
                        <div style="display: inline-block; width:48%; text-align: left" *ngIf="showReAssignedFilter">
                            <label class="label-field-override">
                                <mat-checkbox labelPosition="before"
                                    [(ngModel)]="searchQBE.includeReAssigned">Just Show Reassigned
                                    Requests:&nbsp;&nbsp;&nbsp;</mat-checkbox>
                            </label>
                        </div>
                    </div>
                    <div style="padding-top: 7px;">
                    	<div style="display: inline-block; width:50%; text-align: left; padding-right: 10px;">
                            <label class="label-field-override">Request Id:</label>
                            <span class="form-required"> </span>

                            <input mat-input [disabled]="disabledFlag"
                           matTooltip="Enter a request Id"
                           id="requestId"
                           class="input-field-short"
                           [(ngModel)]="searchQBE.requestId"
                           style="position: relative; z-index: 10;">
                        </div>
                         <div style="display: inline-block; width:50%; text-align: left;">
                            <label class="label-field-override">
                                <mat-checkbox labelPosition="before"
                                    [(ngModel)]="searchQBE.showCollaborationFlag">Just Show Collaboration
                                    Requests:</mat-checkbox>
                            </label>
                        </div>
                    </div>
                    <div style="height: 15px;"></div>
                </div>

                <!-- status box -->

                <div style="display: inline-block;width: 340px; vertical-align: top;" *ngIf="(showUnLimitedStatusFilter || showRestrictedStatusFilter)">

                    <div style="display: inline-block; vertical-align: top;">
                    <label class="label-field-override" style="
                    padding-top: 8px;padding-left: 5px;width: 100px;">Status:</label>
                    </div>
                    <div style="display: inline-block;">
                   <mat-selection-list #shoes class="status-container"  [disabled]="disabledFlag">
                        <ng-container *ngFor="let status of requestStatusList">
                            <mat-list-option>
                                <mat-checkbox [ngModel]="status.isSelected" style="scale: 93%"
                                              (ngModelChange)="status.isSelected = $event">
                                    {{ status.shortDescription }}
                                </mat-checkbox>
                            </mat-list-option>
                        </ng-container>
                    </mat-selection-list>
                    </div>
                </div>
        </div>

      </div>
    </div>
    <!-- Clear / Search Strip -->
    <div style="display: inline-block; width: 33%;color: lightcoral;">
        {{this.maxWarn}}
    </div>
    <div style="display: inline-block; text-align:center; width: 33%;
            margin-top: 28px; padding-bottom: 10px;">
         <button mat-button class="command-button"
                (click)="searchButtonClicked()"
                matTooltipPosition="above"
                matTooltip="Search requests"
                mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Search
        </button>
        <button mat-button class="command-button"
                matTooltipPosition="above"
                (click)="resetQueryCriteria()"
                matTooltip="Clear fields" mat-button>
            <mat-icon>highlight_off</mat-icon>
            Reset
        </button>
    </div>

    <div style="display: inline-block; text-align: right; width:33%;font-size:9pt">
        Results: {{pagination}}
    </div>

    <mat-divider style="padding-bottom: 5px;"> </mat-divider>
    <!-- Results Table -->
    <div>
    <div class="table-container mat-elevation-z1" style="height:290px; width:100%"
         (keydown)="tableKeyDown($event)" tabindex="-1">

        <table mat-table [dataSource]="dataSource" matSort
               class="table-header-style-override"
               (matSortChange)="onSortChange($event)">
            <!-- Select -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="table-header-style-override" style="width: 5px;">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  [(ngModel)]="headerSelect"
                                  (change)="toggleAllSelected($event)"></mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let element;let tableRowIdx = index;"
                    style="width:5px !important;">
                    <mat-checkbox (click)="$event.stopPropagation();"
                                  (change)="runChecked($event)"
                                  [disabled]="false"
                                  [value]="element.select" [(ngModel)]="element.select" >
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Case Number -->
            <ng-container matColumnDef="caseNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="table-header-style-override"
                    style="width: 70px;">Case #
                </th>
                <td mat-cell
                    class="table-detail-style-override"
                    *matCellDef="let element;let tableRowIdx = index;">
                    {{element.caseNumber}}</td>
            </ng-container>

            <!-- First Name -->
            <ng-container matColumnDef="caseName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="table-header-style-override"
                    style="width: 150px;">Case Name
                </th>
                <td mat-cell
                    class="table-detail-style-override"
                    *matCellDef="let element;let tableRowIdx = index;">
                    {{element.caseName}}</td>
            </ng-container>

            <!-- Service Request Id -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="table-header-style-override"
                    style="width: 30px;">Id
                </th>
                <td mat-cell
                    class="table-detail-style-override"
                    *matCellDef="let element;let tableRowIdx = index;">
                    {{element.id}}</td>
            </ng-container>

            <!-- Request Type -->
            <ng-container matColumnDef="serviceRequestDesc">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="table-header-style-override"
                    style="width: 150px;">Request Type
                </th>
                <td mat-cell
                    class="table-detail-style-override"
                    *matCellDef="let element;let tableRowIdx = index;">
                    {{element.serviceRequestDesc}}</td>
            </ng-container>

            <!-- Match Agency -->
            <ng-container matColumnDef="agencyName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="table-header-style-override"
                    style="width: 190px;">Agency
                </th>
                <td mat-cell
                    class="table-detail-style-override"
                    *matCellDef="let element;let tableRowIdx = index;">
                    {{element.agencyName}}</td>
            </ng-container>

            <!-- Param Date -->
            <ng-container matColumnDef="dateCreated">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="table-header-style-override"
                    style="width: 80px;">Date
                </th>
                <td mat-cell
                    class="table-detail-style-override"
                    *matCellDef="let element;let tableRowIdx = index;">
                    {{element.dateCreated | date:'mediumDate':'EST'}}</td>
            </ng-container>

            <!-- Request Status -->
            <ng-container matColumnDef="requestStatusDesc">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="table-header-style-override"
                    style="width: 100px;">Status
                </th>
                <td mat-cell
                    class="table-detail-style-override"
                    *matCellDef="let element;let tableRowIdx = index;">
                   {{element.requestStatusDesc}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row
                *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                [ngClass]="{'row-selected': tableRowIdx == Idx}"
                (click)="onRowClicked(row)" >
            </tr>
        </table>
         <app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
         <div class="no-records-found" [hidden]="!noRecordsReturned">No
             Records Found</div>
    </div>
    </div>
    <!----------------------->
    <!-- ERROR LINE --------->
    <!----------------------->
    <div class="error-line" [hidden]='!strErr.length'
         style="text-align:left; bottom:55px; left: 15px;">{{strErr}}</div>
    <!----------------------->
    <!-- SAVE STRIP        -->
    <!----------------------->
    <div style="text-align:center; margin-top: 28px;">
        <button mat-button class="command-button" [disabled]="!enableSubmit"
                (click)="onSubmitClicked()" matTooltip="Submit / save this entry"
                mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Select
        </button>
        <button mat-button class="command-button"
                (click)="onCancelClicked()" matTooltip="Cancel without saving this entry" mat-button>
            <mat-icon>highlight_off</mat-icon>
            Cancel
        </button>
    </div>
</div>
